<template>
  <div>
    <h1>Bitcoin price</h1>
    <section v-if="errored">
      <p>
        We're sorry, we're not able to retrieve this information at the moment,
        please try back later
      </p>
    </section>

    <section v-else>
      <div v-if="loading">Loading...</div>
      <div v-else class="container">
        <div v-for="currency in info" :key="currency.id" class="currency">
          {{ currency.description }}:
          <span class="lighten">
            <span v-html="currency.symbol"></span
            >{{ currency.rate_float | currencydecimal }}
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      info: null,
      loading: true,
      errored: false
    };
  },
  mounted() {
    axios
      .get("https://api.coindesk.com/v1/bpi/currentprice.json")
      .then(response => (this.info = response.data.bpi))
      .catch(error => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
  filters: {
    currencydecimal(value) {
      return value.toFixed(2);
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
  border: 1px solid silver;
  background: black;
  color: whitesmoke;
  border-radius: 20px;
  max-width: 550px;
  font-size: 200%;
}
</style>
